import { Injectable } from "@angular/core";
import { SecurityService } from "../security/services/security.service";
import { NotificationListClientService } from "./communication/notification-list-client.service";
import { NotificationListSend } from "./model/notification-list.model";
import { Observable } from "rxjs";



@Injectable({
  providedIn: 'root'
})
export class NotificationListService {

    constructor(private notificationListClientService: NotificationListClientService
      ) {}


    getNotificationListUsersMinimal(): Observable<Array<NotificationListSend>> {
        return this.notificationListClientService.getNotificationListUsersMinimal();
    }


    getNotificationListUsersAll(): Observable<Array<NotificationListSend>> {
        return this.notificationListClientService.getNotificationListUsersAll();
    }

    deleteNotification(uuid: string): Observable<void> {
      return this.notificationListClientService.deleteNotification(uuid);
    }

    muteNotificationType(type: string): Observable<void> {
          return this.notificationListClientService.muteNotificationType(type);
    }

}
